import FinancialsTemplateFieldsFragment from "components/financials/modern/graphql/fragments/FinancialsTemplateFieldsFragment";
import IndicatorFieldsFragment from "components/financials/modern/graphql/fragments/IndicatorFieldsFragment";
import gql from "graphql-tag";

export default gql`
  query UserFinancialsTemplates(
    $filters: FinancialsTemplatesQueryFilters
    $orderBy: FinancialsTemplatesQueryOrder
    $limit: Int = 30
    $cursor: Cursor = null
  ) {
    financialsTemplates(filters: $filters, orderBy: $orderBy, limit: $limit, cursor: $cursor)
      @connection(key: "UserFinancialsTemplates") {
      nodes {
        ...FinancialsTemplateFields
        indicators {
          ...IndicatorFields
        }
      }
      totalCount
      pageInfo {
        cursor
        hasNextPage
      }
      breakdown {
        archivedCount
        myTemplatesCount
        publicCount
      }
    }
  }

  ${IndicatorFieldsFragment}
  ${FinancialsTemplateFieldsFragment}
`;
